import React, { useRef } from 'react';
import classNames from 'classnames';
import ReactPlayer from 'react-player';

export const VimeoEmbed = ({ url, controls = true, className }) => {
    const playerRef = useRef(null);

    return (
        <div
            className={classNames(className, 'relative')}
            style={{ paddingTop: controls ? '56.25%' : '' }}>
            <ReactPlayer
                ref={playerRef}
                url={url}
                width="100%"
                height="100%"
                controls={controls}
                allowFullScreen
                webkitallowfullscreen="true"
                mozallowfullscreen="true"
                // playing={!!(poster && !showPoster)}
                pip={false}
                style={{ position: controls ? 'absolute' : '', top: 0, left: 0 }}
            />
        </div>
    );
};

export default VimeoEmbed;
